<template>
  <div class="input-group form-search-rounded">
    <input
      class="form-control py-2 border-right-0 border"
      :value="value"
      @input="$emit('input', $event.target.value)"
      type="search"
      :placeholder="placeholder"
    />
    <span class="input-group-append">
      <div class="input-group-text bg-transparent">
        <a href="#" class="text-blue" @click.prevent="onSearchClick">
          <i class="fa fa-search"></i>
        </a>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  name: "SearchInput",
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Cari material di sini...'
    }
  },
  methods: {
    onSearchClick() {
      this.$emit('search', this.value)
    }
  }
}
</script>
